window.RS = window.RS || {};

RS.Ketch = (function() {
  const YIELDIFY = 'https://td.yieldify.com/yieldify/code.js?w_uuid=81da5b88-cf70-4d6b-87e7-d45f57cd8a3e&k=1&loca=';
  const ATTENTIVE_CHECKOUT = 'https://cdn.attn.tv/checkout/checkout.js';
  const ATTENTIVE_DTAG = 'https://cdn.attn.tv/aerosoles/dtag.js';
  const DEFER = 'defer';
  const ASYNC = 'async';
  const {
    granted,
    denied,
    functionality,
    analytics,
    ad
  } = RS.Consent.consts;

  const LUT = {
    'essential_services': functionality,
    'analytics': analytics,
    'behavioral_advertising': ad
  }

  function attachScript(id, src, attr = ASYNC) {
    if ( !src || (id && document.getElementById(id))) return;
    let script = document.createElement('script');
    if ( id ) {
      script.id = id;
    }
    script.type = 'text/javascript';
    script.src = src;

    switch (attr) {
      case ASYNC:
        script.async = true;
      break;
      case DEFER:
        script.defer = true;
      break;
    }
    document.head.appendChild(script);
  }

  function setConsentMode(props) {
    const consent = {};

    Object.keys(props).forEach(function(key) {
      var mapped = LUT[key];
      var value = props?.[key] === true ? granted : denied;
      consent[mapped] = value;
    });

    RS.Consent.update(consent);
  }

  function setupYieldify() {
    const src = `${YIELDIFY}${window.location.href}`;
    attachScript('yieldify', src);
  }

  function setupAttentive(url) {
    // fire only on checkout 
    if ( url.indexOf('orders') >= 0 || url.indexOf('checkouts') >= 0 ) {
      attachScript('attentive-checkout', ATTENTIVE_CHECKOUT, DEFER);
    }
    // still pending removal of checkout additional script ( two dtags )
    attachScript('attentive-dtag', ATTENTIVE_DTAG);
  }

  function setupMetaPixel() {
    if (fbq) {
      fbq('consent', 'grant');
    }
  }

  function configMarketing(granted) {
    const url = document.location.href;
    if ( typeof granted == 'boolean' ) {
      if ( granted ) {
        /* yieldify */
        // setupYieldify();
        /* end yieldify */

        /* attentive */
        setupAttentive(url);
        /* end attentive */
      } else {
        console.log('>> behavioral_advertising granted:', granted);
      }
    }
  }

  function configAnalytics(granted) {
    if ( typeof granted == 'boolean' ) {
      if ( granted ) {
        /* Meta Pixel */
        setupMetaPixel();
        /* end Meta Pixel */
      } else {
        /* Triple Whale */
        if ( window.TriplePixel ) {
          TriplePixel('gdpr');
        }
        /* nostojs.setDoNotTrack */
        if ( window.nostojs ) {
          nostojs(api => api.visit.setDoNotTrack(true));
          nostojs(api => console.log('>> Nosto setDoNotTrack', api.visit.isDoNotTrack()));
        } 
      }
    }
  }

  function configEssentialServices(granted) {
    if ( typeof granted == 'boolean' && granted == false ) {
      // TODO
    }
  }
  function loadTagsOnPage(purposes, purposesKeys) {
    purposesKeys.forEach(key => {
      switch(key) {
        case 'essential_services':
          //configEssentialServices(purposes[key]);
          break;
        case 'analytics':
          configAnalytics(purposes[key]);
          break;
        case 'behavioral_advertising':
          configMarketing(purposes[key]);
          break;
      }
    });
  }

  // Add event listener to be called anytime permit values are loaded
  //  or when an end-user updates their consent.
  window.semaphore.push(['onConsent', function(c) {
    var props = Object.assign({}, c.purposes);
    setConsentMode(props);
    var puporsesKeys = Object.keys(c.purposes);
    loadTagsOnPage(c.purposes, puporsesKeys);
  }])

  return {
    setConsentMode
  }

})();